import { NgModule } from '@angular/core';

import { SecurityService }                from './security.service';
import { SharedModule }                   from '../shared/shared.module';
import { SpamProtectionActionsComponent } from './security.spam-protection.actions.component';
import { SpamProtectionComponent }        from './security.spam-protection.component';
import { TableModule }                    from '../table/table.module';

@NgModule({
  declarations: [
    SpamProtectionActionsComponent,
    SpamProtectionComponent
  ],
  entryComponents: [
    SpamProtectionActionsComponent,
    SpamProtectionComponent
  ],
  exports: [
    SpamProtectionComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    SecurityService
  ]
})
export class SecurityModule {}
